var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"super-admin-video-material"},[_c('VideoInstruction',{attrs:{"headTitle":("" + (_vm.$t('videoMaterials'))),"role":'superAdmin'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }